// src/components/Card.js
import React from "react";
import "./Card.css";

function Card({ image, title, text }) {
	return (
		<div className="card">
			<img src={image} alt={title} className="card-image" />
			<h3 className="card-title">{title}</h3>
			<p>{text}</p>
		</div>
	);
}

export default Card;
